'use strict';

var _ = require('lodash');

module.exports = {
  
  /**
   * Set the layer style
   * 
   * @param {Object} style
   */
  setStyle: function (style) {
    // jshint unused:false
    // child override
  },

  /**
   * Update the layer state style
   */
  setStyleForState: function (state) {
    var states = {
      active: this._setStateStyleToActive.bind(this),
      default: this._setStateStyleToDefault.bind(this),
      dim: this._setStateStyleToDim.bind(this),
    };

    var styleFn = states[state];
    if (!styleFn) {
      throw new Error('Unknown layer state style: ' + state);
    }

    styleFn();
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/base/mixins/StyleMixin.js